// TODO: Rota para coletar informações do usuario

// Configurações
const baseURL = {
  local: 'http://localhost:5000',
  dev: 'https://dev.aawz.com.br',
  // dev: 'http://aawz-server-homolog.us-east-2.elasticbeanstalk.com',
  test: 'https://httpbin.org',
  prod: 'https://portal.aawz.com.br',
}

const mirror = '/mirror'

const produto = {
  /**
   * @deprecated Usar POST pagarme.professional_add_client
   */
  add_cliente_wirecard: '/v2/api/professional/card_data/add_client',
  /**
   * @deprecated Usar POST pagarme.professional_add_card
   */
  add_cartao_wirecard: '/v2/api/professional/card_data/add_card',
  /**
   * Enviar id do cartão da rota de adicionar cartao
   * enviar numero de parcelas (entre 1 e 12)
   */
  contratar: '/v2/api/relatorio-setorial/contratar',
  confirmar: '/v2/api/professional/relatorio-setorial/confirmacao',
  listar_relatorios: '/v2/api/relatorio-setorial', // GET
}

const utils = {
  contato: '/v2/api/utils/contact-us',
}

const pagarme = {
  /**
   * @method POST Adicionar cliente (visão de cliente).
   * @method GET Verificar se existe o cliente.
   *  @return status 200 -> tem cadastro e cartão.
   *  @return status 403 -> tem cadastro mas não tem cartão.
   *  @return status 404 -> não tem cadastro nem tem cartão.
   * Parametros iguais anteriores.
   */
  client_add_client: '/v2/api/payments/pagarme/payer/client/account',
  professional_add_client:
    '/v2/api/payments/pagarme/payer/professional/account',
  /**
   * @method POST Adicionar cartão (visão de cliente).
   * @method GET Coletar cartões cadastrados na pagarme.
   * @method DELETE Excluir cartões.
   * Parametros iguais anteriores.
   */
  client_add_card: '/v2/api/payments/pagarme/payer/client/credit-card',
  professional_add_card:
    '/v2/api/payments/pagarme/payer/professional/credit-card',
}

const profissional = {
  /**
   * @param {String} email obrigatorio
   * @param {String} senha obrigatorio
   * @param {String} numero_doc ou cpf
   * @param {String} telefone
   * @param {String} nome
   */
  adicionar: '/v2/api/relatorio-setorial/register-account',
  /**
   * Tipo login, verifica as credenciais.
   * @param {String} email
   * @returns
   *  404 - Profissional não encontrado
   *  200 - Profissional encontrado
   */
  check_account: '/v2/api/relatorio-setorial/check-account',
  /**
   * Valida o email na base
   * @param {String} email
   * @param {String} senha
   */
  check_email: '/v2/api/relatorio-setorial/check-email',
}

module.exports = {
  baseURL,
  produto,
  profissional,
  pagarme,
  utils,
  mirror,
}
